import { render, staticRenderFns } from "./Wh5eAuthChoose.vue?vue&type=template&id=5216a034&scoped=true"
import script from "./Wh5eAuthChoose.vue?vue&type=script&lang=js"
export * from "./Wh5eAuthChoose.vue?vue&type=script&lang=js"
import style0 from "./Wh5eAuthChoose.vue?vue&type=style&index=0&id=5216a034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5216a034",
  null
  
)

export default component.exports